module.exports = __webpack_public_path__ + "static/media/milxc-iutAS-step1.ebcfc094.png";